import { render } from "./SearchingBar.component.vue?vue&type=template&id=fb2b14f6&ts=true"
import script from "./SearchingBar.component.vue?vue&type=script&lang=ts"
export * from "./SearchingBar.component.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/SMSFrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__